















































































































import { AxiosError } from 'axios';
import Vue from 'vue';
import { PropType } from 'vue';
import { mapActions, mapGetters } from 'vuex';
import {
  IAttachment,
  IOvertimeRequest,
  OvertimeRequestComment,
  OvertimeRequestCommentAttachment
} from '@/models';
import { ErrorManager } from '@/models/error';
import { isHtmlTextEmpty } from '@/utils/helpers';

import CommentAttachmentList from '@/components/common/CommentAttachmentList.vue';
import QuillEditor from '../common/QuillEditor.vue';
import OvertimeRequestCommentListItem from './OvertimeRequestCommentListItem.vue';

export default Vue.extend({
  name: 'OvertimeRequestCommentList',

  components: {
    CommentAttachmentList,
    QuillEditor,
    OvertimeRequestCommentListItem
  },

  props: {
    overtimeRequest: {
      type: Object as PropType<IOvertimeRequest>,
      required: true
    }
  },

  data() {
    return {
      loading: false,
      isEditing: false,

      commentLoading: false,

      commentErrorMessage: '',
      commentErrorMessageDetail: '',

      comment: new OvertimeRequestComment(),

      mentionsLoading: false,

      attachments: [] as IAttachment[],
      overtimeRequestCommentValid: false
    };
  },

  computed: {
    ...mapGetters({
      comments: 'overtimeRequest/getOvertimeRequestComments',
      mentionableUsers: 'overtimeRequest/getOvertimeRequestMentionableUsers',
      getLastCreatedOvertimeRequestCommentId:
        'overtimeRequest/getLastCreatedOvertimeRequestCommentId'
    }),

    canSaveComment(): boolean {
      return !isHtmlTextEmpty(this.comment.text) && !this.commentLoading;
    }
  },

  mounted() {
    this.loading = true;
    this.fetchOvertimeRequestComments(this.overtimeRequest.id)
      .catch(error => {
        if (error.response) {
          if (error.response.data.detail) {
            this.commentErrorMessageDetail = error.response.data.detail;
          }
        }
        this.commentErrorMessage = ErrorManager.extractApiError(error);

        this.updateErrorMessage();
      })
      .finally(() => {
        this.loading = false;
      });
  },

  methods: {
    ...mapActions({
      fetchOvertimeRequestComments:
        'overtimeRequest/fetchOvertimeRequestComments',
      createOvertimeRequestComment:
        'overtimeRequest/createOvertimeRequestComment',
      fetchOvertimeRequestCommentsMentionableUsers:
        'overtimeRequest/fetchOvertimeRequestCommentsMentionableUsers',
      addOvertimeRequestCommentAttachments:
        'overtimeRequest/addOvertimeRequestCommentAttachments'
    }),

    addBaseAttachments(files: File[]) {
      this.attachments.push(
        ...files.map(
          file => new OvertimeRequestCommentAttachment({ file: file })
        )
      );
    },

    updateErrorMessage() {
      this.$emit('setErrorMessage', {
        errorMessage: this.commentErrorMessage,
        errorMessageDetail: this.commentErrorMessageDetail
      });
    },

    clearAllErrors(): void {
      this.commentErrorMessage = '';
      this.commentErrorMessageDetail = '';

      this.updateErrorMessage();
    },

    addOvertimeRequestComment() {
      this.clearAllErrors();

      this.commentLoading = true;

      const parsedCommentMentionText = OvertimeRequestComment.parseHtmlToMentionText(
        this.comment.text
      );

      return this.createOvertimeRequestComment({
        overtimeId: this.overtimeRequest.id,
        comment: { ...this.comment, text: parsedCommentMentionText }
      })
        .then(async () => {
          this.comment = new OvertimeRequestComment();
          if (this.attachments.length !== 0) {
            await this.addOvertimeRequestCommentAttachments({
              overtimeId: this.overtimeRequest.id,
              commentId: this.getLastCreatedOvertimeRequestCommentId,
              attachments: this.attachments
            });
            this.attachments = [];
          }
        })
        .catch(error => {
          if (error.response) {
            if (error.response.data.detail) {
              this.commentErrorMessageDetail = error.response.data.detail;
            }
          }
          this.commentErrorMessage = ErrorManager.extractApiError(error);

          this.updateErrorMessage();
        })
        .finally(() => {
          this.commentLoading = false;
        });
    },

    async loadMentionableUsers() {
      this.clearAllErrors();

      this.mentionsLoading = true;
      try {
        await this.fetchOvertimeRequestCommentsMentionableUsers(
          this.overtimeRequest.id
        );
      } catch (error) {
        this.commentErrorMessage = ErrorManager.extractApiError(
          error as AxiosError
        );
      } finally {
        this.mentionsLoading = false;
      }
    }
  }
});
